export default {
  goBackMyData: 'Мои данные',
  goBackProfile: 'Профиль',
  passport: {
    navText: 'Паспорт',
    title: 'Основной разворот паспорта',
    annotation: 'Загрузите основной разворот с местом и датой выдачи.\n Следите за читаемостью информации на фотографии',
    successMessage: 'Основной разворот загружен'
  },
  registration: {
    navText: 'Прописка',
    title: 'Страница с пропиской',
    annotation: 'Загрузите страницу с пропиской из паспорта.\n Следите за читаемостью информации на фотографии',
    successMessage: 'Прописка загружена'
  },
  snils: {
    navText: 'СНИЛС',
    title: 'СНИЛС',
    annotation: 'Загрузите основной разворот с местом и датой выдачи.\n Следите за читаемостью информации на фотографии',
    successMessage: 'СНИЛС загружен'
  },
  inn: {
    navText: 'ИНН',
    title: 'ИНН',
    annotation: 'Загрузите свое свидетельство ИНН.\n Следите за читаемостью информации на фотографии',
    successMessage: 'Свидетельство загружено'
  },
  next: 'Далее',
  sendToReview: 'Отправить на проверку',
  sendDocsSuccessMessage: 'Документы успешно отправлены на проверку 👍',
  sendDocsErrorMessage: 'При отправке документов произошла ошибка 🤔'
}
